import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import dateHelper from './dateHelper';

export default class MetaData extends React.Component{
    render(){
        return(
            <Table style={{backgroundColor:'#ccc'}}>
                <TableHead>
                    <TableRow>
                        {
                            (this.props.rows || []).map((row,index) => <TableCell key={index}>{row.name}</TableCell>)
                        }
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {
                            (this.props.rows || []).map((row, index) => <TableCell key={index + 100}>
                                {dateHelper.toShortDateOrOriginal(row.value)}
                            </TableCell>)
                        }
                    </TableRow>
                </TableBody>
            </Table>
        );
    }
}